// extracted by mini-css-extract-plugin
export default {"container":"PalletAmountAsLogisticMinimumInfo_container__HsDEO","amountInfo":"PalletAmountAsLogisticMinimumInfo_amountInfo__T-MiI"};